export default __webpack_public_path__ + "ac69ec24e010df2c0b6122d2470ca0a6.jpg";